import { gql } from '@apollo/client';
import ErrorResultFragment from "../../fragments/ErrorResult";
import Poll from "../../fragments/Poll";
import ProductFragment from '../../fragments/Product';

const CREATE_NEWSPOST = gql`
 mutation CreateNewsPost($input: NewsInput) {
  newsContext {
    createNewsPost(input: $input) {
      errorResult {
        ...ErrorResultFields
      }
      success
      result {
        author
        avatarUrl
        allowComments
        category
        createdDate
        id
        image
        itemType
        leadText
        site
        thumbnail
        title
        viewCount
        newsPost
        poll {
          ...PollFragment
        }
        likes {
          userId
          name
          emoticon
          isCurrentUser
        }
        mentions {
          avatarUrl
          mentionId
          name
          username
          userId
        }
        comments {
          commentDate
          text
          username
          author
          authorId
          avatarUrl
          commentId
          mentions {
            avatarUrl
            mentionId
            name
            username
            userId
          }
          likes {
            userId
            name
            emoticon
            isCurrentUser
          }
        }
        images {
          imageUrl
        }
        products {
          ...ProductFields
        }
      }
    }
  }
}

  ${ErrorResultFragment}
  ${Poll}
  ${ProductFragment}
`;

export default CREATE_NEWSPOST;
